import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import bananaImage from "@/assets/agent/banana@3x.webp";

export const BananaImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[bananaImage]}
      {...props}
    />
  );
};

BananaImage.displayName = 'BananaImage';
